import React, { useEffect, useRef, useState } from 'react';
import { formatToZMW, handlePrint, rootUrl, handleExcel } from '../../../helpers';
import axios from 'axios';
import { useOutletContext } from 'react-router-dom';
import { useAuth } from '../../../context/auth-context';
import { toast } from 'react-toastify';
import FormGenerator from '../../../components/formGenerator';
import { FaFolderOpen, FaPrint, FaFileExcel } from 'react-icons/fa';
import BudgetForm from './form';

export default function SupplierStatement({ id, name }){
    const [data, setData] = useState([]); 
    const [balance, setBalance] = useState(0.0); 
    const [loading, setLoading] = useState(false); 
    const [error, setError] = useState(null); 
    const [makePayment, setMakePayment] = useState(false);
    const [projects, setProjects] = useState([]);

    useEffect(()=>{
        fetchData()
        axios.get(rootUrl(`/getProjs`))
        .then(response => {  
          setProjects(response.data.data); 
        })
        .catch(error => {
            setError('Error fetching data');
            console.error(error);
        })
    }, [])


    const auth = useAuth();
    const {allData, setAllData} = useOutletContext();


    const fetchData = () => {
        setLoading(true); 
        setError(null); 
        axios.get(rootUrl(`/suppliertrans/${id}`))
            .then(response => {  
                setData(response.data.suppliers); 
            })
            .catch(error => {
                setError('Error fetching data');
                console.error(error);
            })
            .finally(() => setLoading(false)); // Stop loading
    };

      const onSubmitForm = async (formData) => {
        formData['uid'] = auth.user.id
        formData['sid'] = id
        try{
          const response = await axios.post(rootUrl('/addSupPayment'), formData)
          if(response.data.status === 200){
            toast.success("Submitted successfully")
            setMakePayment(false)
          }else{
            toast.error("Something went wrong")
          }
    
        }catch(e){
          toast.error(e?.message)
        }
      }
      const componentRef = useRef(null)

    return (
        <div className="w-full">
            {loading && (
              <div className="flex justify-center items-center py-6">
                <p className="text-sm text-gray-600">Loading...</p>
              </div>
            )}
            {error && <p className="text-red-500 text-sm mb-2">{error}</p>}
            
            {data.length === 0 && !loading ? (
                <div className="flex flex-col justify-center items-center py-10">
                  <FaFolderOpen className="text-gray-400 text-6xl mb-2" />
                  <p className="text-gray-600 text-sm">No data available</p>
                </div>
            ) : (
                <>
                  <div className="flex justify-end gap-2 mb-3">
                    <button
                      onClick={() => handlePrint(componentRef)}
                      className="inline-flex items-center bg-blue-950 text-white px-3 py-2 rounded-lg text-xs md:text-sm hover:bg-blue-900"
                    >
                      <FaPrint className="mr-1" />
                      Print
                    </button>
                    <button
                      onClick={() => handleExcel(componentRef, `SupplierStatement`)}
                      className="inline-flex items-center bg-blue-950 text-white px-3 py-2 rounded-lg text-xs md:text-sm hover:bg-blue-900"
                    >
                      <FaFileExcel className="mr-1" />
                      Excel
                    </button>
                  </div>
                  <div ref={componentRef} className="border border-gray-200 rounded-xl p-4 md:p-6 m-2 md:m-4 bg-white">
                    <div className="flex justify-center mb-2">
                      <img className="w-[200px]" src={rootUrl(`/${allData?.council[0]?.path}`)} alt="Council Logo" />
                    </div>
                    
                    <h2 className="text-center font-bold text-2xl text-gray-900">{allData?.council[0]?.name}</h2>
                    <h3 className="text-center font-semibold text-lg text-gray-800 mt-1">Supplier Statement Of Account</h3>
                    <hr className="my-3" />
                    <p className="text-lg font-semibold text-center text-gray-700 mb-3">{name}</p>
                    <table className="min-w-full border border-gray-300 text-sm">
                      <thead>
                        <tr className="text-left bg-blue-950 text-white">
                          <th className="border-b px-4 py-2">Date</th>
                          <th className="border-b px-4 py-2">Invoice #</th>
                          <th className="border-b px-4 py-2">Description</th>
                          <th className="border-b px-4 py-2">Debit</th>
                          <th className="border-b px-4 py-2">Credit</th>
                          <th className="border-b px-4 py-2">Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(() => {
                          let runningBalance = 0;
                          let totalDebit = 0;
                          let totalCredit = 0;

                          const rows = data.map((res, index) => {
                            if (
                              (allData.budget.find(a => a.id === res.coa)?.coa == "321040" ||
                                allData.budget.find(a => a.id === res.coa)?.coa == "321040") &&
                              res.type == 1
                            ) {
                              return null;
                            }

                            const debit = res.type == 1 ? parseFloat(res.amount) : 0;
                            const credit = res.type == 2 ? parseFloat(res.amount) : 0;

                            totalDebit += debit;
                            totalCredit += credit;
                            runningBalance += debit - credit;

                            return (
                              <tr key={index}>
                                <td className="border-b px-4 py-2">{res.date.substring(0, 10)}</td>
                                <td className="border-b px-4 py-2">
                                  {res.invoice != null ? res?.invoice : res?.receipt_no}
                                </td>
                                <td className="border-b px-4 py-2">{res.comment}</td>
                                <td className="border-b px-4 py-2">{formatToZMW(debit)}</td>
                                <td className="border-b px-4 py-2">{formatToZMW(credit)}</td>
                                <td className="border-b px-4 py-2">{formatToZMW(runningBalance)}</td>
                              </tr>
                            );
                          });

                          return (
                            <>
                              {rows}
                              <tr className="bg-gray-100 font-semibold">
                                <td className="border-t px-4 py-2 text-right" colSpan="3">Total</td>
                                <td className="border-t px-4 py-2">{formatToZMW(totalDebit)}</td>
                                <td className="border-t px-4 py-2">{formatToZMW(totalCredit)}</td>
                                <td className="border-t px-4 py-2">{formatToZMW(runningBalance)}</td>
                              </tr>
                            </>
                          );
                        })()}
                      </tbody>
                    </table>
                    <br/>
                  </div>
                  <button
                    className="border border-blue-900 rounded-lg px-4 py-2 my-2 bg-blue-950 text-white m-4 text-sm md:text-base hover:bg-blue-900"
                    onClick={()=>setMakePayment(!makePayment)}
                  >
                    Add Payment
                  </button>
                </>
            )}

            {makePayment && (
              <>
                <span className="font-bold text-lg m-4 block">Make Payment</span>
                <hr className="mb-3" />
                <div className="m-2 p-2">
                  <BudgetForm data={data} allData={allData} onSubmitForm={onSubmitForm} />
                </div>
              </>
            )}
        </div>
    );
};



